<template>
  <el-dialog :title="title" :visible="dialogFormVisible"  :before-close="handleClose" :closeOnClickModal="false">
        <el-form :label-width="labelwidth" ref="model" :model="model" :rules="rules" :label-position="labelPosition" >
            <el-form-item label="类型名称" prop="CategoryName" >
                <el-input size="small" v-model="model.CategoryName" auto-complete="off" placeholder="请输入类型名称" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="Sort">
                <el-input size="small" v-model.number="model.CategorySort" auto-complete="off" placeholder="请输入序号" maxlength="100"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='handleClose'>取消</el-button>
        <el-button size="small" type="primary"  class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {AddDACategorylist} from '../../../api/device'
export default {
    data() {
        return {
            title: '添加应用类型',
            name: 'add',
            labelwidth: '120px',
            labelPosition: 'right',
            baseURL: window.Global.baseURL,
            model: {
                CompanyCode:'',
                DeviceCode: '',
                CategoryName: '',
                CategorySort: 0
            },
            rules: {
                CategoryName: [{ required: true, message: '请输入类型名称', trigger: 'blur' }],
                CategorySort: [{ required: true, message: '请输入序号', trigger: 'blur',type: 'number'}],
            },
        }
    },
    props: {
        dialogFormVisible: {
            required: true,
            type: Boolean
        },
        CompanyCode: {
            required: true,
            type:String
        },
        DeviceCode: {
            required: true,
            type:String
        }
    },
    mounted() {
        this.init();
    },  
    methods: {
        init() {
           this.model.DeviceCode = this.DeviceCode;
           this.model.CompanyCode = this.CompanyCode;
        },
        handleSave() {
            this.$refs.model.validate((valid) => {
                if (valid) {
                    this.AddDACategorylist()
                } else {
                    this.$message({
                        message: '请填写完整信息',
                        type: 'error'
                    });
                }
            });
            
        },
        handleClose() {
            this.$emit('closeAddDialog')
        },
        AddDACategorylist() {
            AddDACategorylist(this.model).then(data=>{
                if(!data.iserror) {
                    this.$message({
                        message: '添加成功',
                        type: 'success'
                    });
                    this.handleClose();
                }
            })
        },
    }
}
</script>

<style>

</style>